export const NakedTable = ({
  data = [],
  columns = [],
  small = false,
  title,
  className,
  maxHeight,
  textWrap = false,
}) => {
  return (
    <div
      style={{
        width: "100%",
        maxWidth: "100%",
        overflow: "auto",
        ...(maxHeight && { maxHeight }),
      }}
      className={`${className} compact`}
    >
      <small>
        <table
          className="table-sm w-100"
          style={{
            border: "2px solid #27293D",
            backgroundColor: "#1E1E27",
            borderRadius: 15,
          }}
        >
          <thead>
            {title && (
              <tr>
                <td
                  colSpan="10000"
                  className="mx-1 text-info font-weight-bold display-5"
                  style={{ fontSize: 16 }}
                >
                  {title}
                </td>
              </tr>
            )}
            <tr>
              {columns.map((column, index) => (
                <th
                  scope="col"
                  key={index}
                  className={`text-info px-2 text-${column.alignment} position-sticky`}
                  style={{
                    border: "2px solid #27293D",
                    top: "-1px",
                    width: column.width,
                    backgroundColor: "#1E1E27",
                  }}
                >
                  <span
                    className={`${(!textWrap || column.noWrap) && "text-nowrap"}`}
                  >
                    {column.header}
                  </span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Boolean(columns.length) && data?.length ? (
              data?.map((row, i) => (
                <tr className={`text-white`} key={i}>
                  {columns.map((column, j) => (
                    <td
                      key={j}
                      className={`px-2 text-${column.alignment}`}
                      style={{
                        border: "2px solid #27293D",
                        width: column.width,
                      }}
                    >
                      <span
                        className={`${(!textWrap || column.noWrap) && "text-nowrap"}`}
                      >
                        {column?.accessor
                          ? column.accessor instanceof Function
                            ? column.accessor(row)
                            : row[column?.accessor]
                          : column.action(row) || (
                              <span className="text-muted">No data</span>
                            )}
                      </span>{" "}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr className="text-muted">
                <td colSpan={columns.length + 1}>No data yet</td>
              </tr>
            )}
          </tbody>
        </table>
      </small>
    </div>
  );
};
